var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{staticClass:"charge-currency"},[_vm._v(_vm._s(_vm.chargeShowCurrency))]),_vm._v(_vm._s(parseFloat(_vm.chargeAmount).toFixed(2)))])}
var staticRenderFns = []

export { render, staticRenderFns }